const cmpPerspectivesRecent = {
    apiEndpoint: null,
    resultsUl: null,

  init: function (element) {
    const _ = this
    _.component = element
    _.apiEndpoint = element.getAttribute('data-api-endpoint')
    _.resultsUl = _.component.querySelector('#recent-articles')

    _.fetchResults()
  },  

  fetchResults: function () {
    const _ = this
    const fetchOpts = {
      method: 'GET',
      headers: {}
    }

    window.fetch(_.apiEndpoint, fetchOpts)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.json()
      }).then((body) => {
        _.processResponse(body)
      }).catch((err) => {
        console.log('Request Failed', err)
      })
  },

  processResponse: function (body) {
    const _ = this
    
    let articles = body.JsonContent.articles
    
    if (articles.length > 0)
    {
        let title = document.querySelector('.cmp-perspectives-detail__recent__title')
        
        if (title)
        {
            if (title.classList.contains('d-none'))
            {
                title.classList.remove('d-none')
            }
        }
    }
    if (articles)
    {
        articles.forEach(function(article) {
            let listItem = document.createElement('li')
            listItem.classList.add('inherit-permalink')

            if (article.imageUrl)
            {
                let imageElement = document.createElement('img')
                imageElement.setAttribute('src',article.imageUrl)
                if(article.imageAltText)
                {
                    imageElement.setAttribute('alt',article.imageAltText)
                }
                else(article.imageAltText)
                {
                    imageElement.setAttribute('alt', "")
                }

                let imageWrapper = document.createElement('div')
                imageWrapper.classList.add('media')
                imageWrapper.appendChild(imageElement)
                listItem.appendChild(imageWrapper)
            }

            if (article.assetClassName)
            {
                let eyebrow = document.createElement('div')
                eyebrow.classList.add('eyebrow')
                let assetClass = document.createTextNode(article.assetClassName)
                eyebrow.appendChild(assetClass)
                listItem.appendChild(eyebrow)
            }

            let title = document.createTextNode(article.title)
            let anchor = document.createElement('a')
            anchor.classList.add('permalink')
            anchor.setAttribute('href',article.url)
            anchor.appendChild(title)

            let h3 = document.createElement('h3')
            h3.classList.add('heading_overwrite_6')
            h3.appendChild(anchor)

            listItem.appendChild(h3)
            _.resultsUl.appendChild(listItem)
        })
    }    
  },

}

export default cmpPerspectivesRecent